export const BROADCAST_CHANNEL_AUTH_SYNC = "AUTH_SYNC_CHANNEL";
export const BROADCAST_CHANNEL_DOCUMENTS = "DOCUMENTS_CHANNEL";

export const BROADCAST_CHANNEL_APP_UPDATE = "APP_UPDATE_CHANNEL";
// Message type for app update required used in BROADCAST_CHANNEL_APP_UPDATE
export const APP_UPDATE_REQUIRED = "APP_UPDATE_REQUIRED";

export const emitOnBroadcastChannel = (channel: string, message) => {
  const bc = new BroadcastChannel(channel);
  bc.postMessage(message);
  bc.close();
};

export const listenOnBroadcastChannel = (channel: string, callback: (any) => void) => {
  const bc = new BroadcastChannel(channel);
  bc.onmessage = callback;
  return () => bc.close();
};
